export function generatePage(pascal: string, kebab: string): string {
  return `import { getSetting } from '@admin/actions/settings'
import * as React from 'react'
import { ${pascal}SubmissionsPageContent } from './${kebab}-submissions-page-content'
import { ${pascal}SubmissionsPageSkeleton } from './${kebab}-submissions-page-skeleton'

export default async function Page() {
  const initialSettings = await getSetting()

  return (
    <React.Suspense fallback={<${pascal}SubmissionsPageSkeleton />}>
      <${pascal}SubmissionsPageContent initialSettings={initialSettings} />
    </React.Suspense>
  )
}
`
}

export function generatePageSkeleton(pascal: string, label: string): string {
  return `export function ${pascal}SubmissionsPageSkeleton() {
  return (
    <div className="flex items-center justify-center h-48">
      <div className="text-muted-foreground">Loading ${label}...</div>
    </div>
  )
}
`
}
